<template>
  <v-layout class="pa-30 lign-center justify-center">
    <v-container class="ma-30 display-3">Page not found :(</v-container>
  </v-layout>
</template>


<script>
export default {};
</script>